import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  GetReportsHeadsetsQueryParams,
  GetReportsHeadsetsResponse,
  GetPackagesParams,
  GetPackagesResponse,
  ActivateHeadsetSubscriptionParams,
  ActivateHeadsetSubscriptionResponse,
  CancelHeadsetSubscriptionsParams,
  CancelHeadsetSubscriptionsResponse,
} from './reportHeadsets.types';
import {
  getReportsHeadsetsAPI,
  activateHeadsetSubscriptionApi,
  cancelHeadsetSubscriptionsApi,
  getPackagesAPI,
} from './reportHeadsets.api';

const prefix = 'reportsHeadsets';

export const getReportsHeadsetsAction = createAsyncThunkFromFetch<
  GetReportsHeadsetsResponse,
  {
    params: GetReportsHeadsetsQueryParams;
  }
>(`${prefix}/headsets`, getReportsHeadsetsAPI);

export const getPackagesAction = createAsyncThunkFromFetch<
  GetPackagesResponse,
  GetPackagesParams
>(`${prefix}/packages`, getPackagesAPI);

export const activateHeadsetSubscriptionAction = createAsyncThunkFromFetch<
  ActivateHeadsetSubscriptionResponse,
  ActivateHeadsetSubscriptionParams
>(`${prefix}/activateHeadsetSubscription`, activateHeadsetSubscriptionApi);

export const cancelHeadsetSubscriptionsAction = createAsyncThunkFromFetch<
  CancelHeadsetSubscriptionsResponse,
  CancelHeadsetSubscriptionsParams
>(`${prefix}/cancelHeadsetSubscription`, cancelHeadsetSubscriptionsApi);
